<template lang="pug">

    .ui.two.columns.grid
        .column
            a.ui.labeled.icon.button(v-on:click='$emit("back")')
                i.chevron.left.icon
                | {{ backLabel }}
        .right.aligned.column
            a.ui.right.labeled.icon.button(v-on:click="cancel()")
                i.remove.icon
                | {{ cancelLabel }}
            button.ui.right.labeled.primary.icon.button
                i.chevron.right.icon
                | {{ nextLabel }}

</template>

<script>

    //noinspection ReservedWordAsName
    export default {

        methods: {
            cancel() {
                this.$router.push({ name: 'products' })
            }
        },

        props: {
            backLabel: {
                type: String,
                default: "Zurück"
            },
            cancelLabel: {
                type: String,
                default: "Abbrechen"
            },
            nextLabel: {
                type: String,
                default: "Weiter"
            },
            showBack: {
                type: Boolean,
                default: true
            }
        }

    }

</script>
